module.exports = __webpack_public_path__ + "img/pic-paging-faq-2.1925d411.jpg";